import { SwitcherButtonStyle } from "../../../types/Interface";

export const CIRCLE_RADIUS = 12;
export const BG_PADDING = 8;
export const COLOR_BUTTON_STYLE: SwitcherButtonStyle = {
  x: 0,
  y: 0,
  width: 2 * CIRCLE_RADIUS,
  height: 2 * CIRCLE_RADIUS,
  defaultBgColor: 0xFF0000,
  pressedBgColor: 0xFFFFFF,
  border: false,
  borderRadius: CIRCLE_RADIUS
}

export const COLORS = [
  0x333333,
  0x4A90E2,
  0x50E3C2,
  0xB8E986,
  0xF8E71C,
  0xF5A623,
  0xD0021B,
  0xBD10E0,
  0x9013FE,
  0x417505,
  0x223344,
  0xFC99C4
];
